import React, { useContext, useEffect, useState } from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import Typeahead from "../../shared/Typeahead/Typeahead";
import IVendorModel from "../../../models/IVendorModel";
import ITypeaheadLookupByTokenTypeDTO from "../../../models/DTO/ITypeaheadLookupByTokenTypeDTO";
import TokenTypesEnum from "../../../models/TokenTypesEnum";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnTypeaheadLookupByTokenTypeDTO from "../../../models/DTO/IOnTypeaheadLookupByTokenTypeDTO";
import IDashboardItem from "../../../models/IDashboardItem";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import INotification from "../../../models/INotification";
import styled from "styled-components";
import OwButton from "../../shared/OwButton/OwButton";
import { useNavigate } from "react-router-dom";
import { Socket } from "socket.io-client";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";

type Props = {
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    inEditor: boolean;
    widget?: IDashboardItem;
    removeWidget?: () => void;
};

const AccountDetailContainer = styled.div`
    padding: 0.5rem;
    justify-content: start !important;
    align-items: start !important;
    height: 100%;

    input {
        width: 100%;
    }

    .position-relative {
        width: 100%;
    }
`;

export const AccountDetailWidget: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const history = useNavigate();

    const [foundVendors, setFoundVendors] = useState<IVendorModel[]>([]);
    const [selectedVendor, setSelectedVendor] = useState<IVendorModel>();
    const [clearTypeahead, setClearTypeahead] = useState(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.TokenOnTypeaheadLookupByTokenType, onTypeaheadVendors);

        return () => {
            props.socket.removeListener(EndpointsEnum.TokenOnTypeaheadLookupByTokenType, onTypeaheadVendors);
        };
    }, []);

    const selectVendor = (vendorModel: IVendorModel) => {
        setSelectedVendor(vendorModel);
    };

    const getTypeaheadVendors = (value: string) => {
        if (!props.inEditor) {
            const payload: ITypeaheadLookupByTokenTypeDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                tokenType: TokenTypesEnum.SUPPLIER_VENDOR,
                name: value,
            };

            props.socket.emit(EndpointsEnum.TokenTypeaheadLookupByTokenType, payload);
        }
    };

    const onTypeaheadVendors = (data: IOnTypeaheadLookupByTokenTypeDTO) => {
        const vendors = data.results.map((token) => {
            return token.Vendor!;
        });

        setFoundVendors(vendors);
    };

    const clearTypeaheadFn = () => {
        setFoundVendors([]);
        setSelectedVendor(undefined);
        setClearTypeahead(false);
    };

    const viewDetail = () => {
        if (selectedVendor) {
            history(`/account/${selectedVendor.guid}/detail`);
        }
    };

    return (
        <AccountDetailContainer className={"widget"}>
            {props.inEditor ? (
                <div>
                    <OwIconButton
                        iconClass={"fas fa-trash-alt"}
                        iconColorClass={"text-danger"}
                        fn={() => {
                            props.removeWidget!();
                        }}
                    />
                </div>
            ) : null}
            <OwLabel title={"account_lookup"} />
            <Typeahead
                isSelectableFn={() => true}
                typeaheadApiFn={getTypeaheadVendors}
                titleProp={"name"}
                typeaheadItems={foundVendors}
                selectedItemFn={selectVendor}
                subTitleProp={"customer_internal_id"}
                clearTypeahead={clearTypeahead}
                clearTypeaheadCallback={clearTypeaheadFn}
            />
            <div className={"mt-2"}>
                <OwButton title={"view_detail"} disabled={!selectedVendor} fn={viewDetail} />
            </div>
        </AccountDetailContainer>
    );
};
